// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';

import { Error } from '../Typography.jsx';
import DatetimeText from '../DatetimeText.jsx';
import NumericText from '../NumericText.jsx';
import Typeahead from '../Typeahead.jsx';

import {
  addHistory,
  deleteHistory,
  updateHistory,
} from '../../actions/pharmacyActions';

import Table from '../Table.jsx';

type Props = {
  drugId: string,
  drug: Object,
  viewOnly: boolean,
  activeAccount: Object,
  addHistory: Function,
  deleteHistory: Function,
  updateHistory: Function,
}

class HistoryTableComponent extends Component < Props > {
  /* eslint-disable no-param-reassign */
  transformDates(formValues) {
    formValues.date = moment(formValues.date, 'DD-MM-YYYY, HH:mm').toISOString();
  }

  handleDeleteRow = (id: string) => {
    const { activeAccount } = this.props;
    this.props.deleteHistory(this.props.drug._id, id, `${activeAccount.name}, ${activeAccount.credential}`);
  }

  handleSaveRow = (id: string, formData: Object) => {
    this.transformDates(formData.values);
    this.props.updateHistory(this.props.drug._id, {
      historyId: id,
      ...formData.values,
    });
  }

  handleSaveNewRow = (formData: Object) => {
    this.transformDates(formData.values);
    this.props.addHistory(this.props.drug._id, formData.values);
  }

  render() {
    const { drug, viewOnly } = this.props;

    // Calculate balance
    const dispensary = drug.dispensary || [];
    let balance = 0;
    dispensary.reverse().forEach((entry) => {
      balance += (entry.quantityIn ? entry.quantityIn : 0);
      balance -= (entry.quantityOut ? entry.quantityOut : 0);
      // eslint-disable-next-line no-param-reassign
      entry.balance = balance;
    });
    dispensary.reverse();

    const columns = [
      {
        Header: 'Date & Time',
        id: 'date',
        cell: item => (item.date ? moment(item.date).format('DD-MM-YYYY, HH:mm') : '--'),
        editCell: item => <DatetimeText field='date' initialValue={item.date} />,
      },
      {
        Header: 'Location',
        id: 'location',
        cell: item => (item.location ? item.location : '--'),
        editCell: item => <Typeahead field='location' initialValue={item.location} endpoint='house' />,
      },
      {
        Header: 'In',
        id: 'quantityIn',
        cell: item => (item.quantityIn ? item.quantityIn : '0'),
        editCell: item => <NumericText field='quantityIn' initialValue={item.quantityIn ? item.quantityIn : '0'} />,
      },
      {
        Header: 'Out',
        id: 'quantityOut',
        cell: item => (item.quantityOut ? item.quantityOut : '0'),
        editCell: item => <NumericText field='quantityOut' initialValue={item.quantityOut ? item.quantityOut : '0'} />,
      },
      {
        Header: 'Balance',
        id: 'balance',
        cell: (item) => {
          if (item.balance === 0) {
            return 0;
          }
          if (!item.balance) {
            return '--';
          }
          if (item.balance < 0) {
            return <Error>{item.balance}</Error>;
          }
          return item.balance;
        },
      },
    ];

    return (
      <Table
        columns = { columns }
        data = { drug.dispensary || [] }
        handleDeleteRow = { viewOnly ? undefined : this.handleDeleteRow }
        handleSaveRow = { viewOnly ? undefined : this.handleSaveRow }
        handleSaveNewRow = { viewOnly ? undefined : this.handleSaveNewRow }
      />
    );
  }
}

const mapStateToProps = state => ({
  activeAccount: state.account.activeAccount,
});

const mapDispatchToProps = dispatch => ({
  addHistory: (drugId, history) => dispatch(addHistory(drugId, history)),
  deleteHistory: (drugId, historyId, editor) => dispatch(deleteHistory(drugId, historyId, editor)),
  updateHistory: (drugId, history) => dispatch(updateHistory(drugId, history)),
});

const HistoryTable = connect(
  mapStateToProps,
  mapDispatchToProps,
)(HistoryTableComponent);

export default HistoryTable;



// WEBPACK FOOTER //
// ./client/src/components/pharmacyPages/HistoryTable.jsx